

const LOCAL_DEV = (process.env['NODE_ENV'] ? process.env['NODE_ENV'] === 'development' : false);

let logLevel = (LOCAL_DEV ? 5 : 1);

const LOG = {

    ERROR: 0,
    WARN: 1,
    INFO: 2,
    DEBUG: 3,
    TRACE: 5,




    error: function (where, message){
        console.error("[ERROR] " + where + " - " + message);
    },

    warn: function (where, message){
        if (logLevel >= 1) {
            console.warn("[WARN] " + where + " - " + message);
        }
    },

    info: function (where, message){
        if (logLevel >= 2) {
            console.info("[INFO] " + where + " - " + message);
        }
    },

    debug: function (where, message){
        if (logLevel >= 3) {
            console.debug("[DEBUG] " + where + " - " + message);
        }
    },

    trace: function (where, message){
        if (logLevel >= 5) {
            console.debug("[TRACE] " + where + " - " + message);
        }
    },
    setLevel: function (level){
        if (level > 0){
            logLevel = level;
        }
    }
};


export default LOG;




// WEBPACK FOOTER //
// ./src/script/utils/logging.js